import { render, staticRenderFns } from "./VScroller.vue?vue&type=template&id=751a044b&scoped=true"
import script from "./VScroller.vue?vue&type=script&lang=js"
export * from "./VScroller.vue?vue&type=script&lang=js"
import style0 from "./VScroller.vue?vue&type=style&index=0&id=751a044b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751a044b",
  null
  
)

export default component.exports